import { get, post } from '../baseService'
import { CreateServerModel } from 'app/models/createServerModel'
import { ServerModel } from 'app/models/serverModel'

const create = () => {
  const getServers = (companyId: string) =>
    get(
      companyId != null
        ? `/config-api/server?&companyId=${companyId}`
        : '/config-api/server',
    )
  const addServer = (server: CreateServerModel) =>
    post('/config-api/server/create', server, false)
  const editServer = (server: ServerModel) =>
    post('/config-api/server/edit', server, false)
  const deleteServer = (ids: string[]): Promise<Array<any>> => {
    const createPromise = (id: string) => {
      return new Promise((resolve, reject) => {
        post('/config-api/server/delete', { id }, false)
          .then((value) => resolve({ id: id, success: true }))
          .catch((error) => reject({ id: id, success: false }))
      })
    }

    const promises = []
    for (const id of ids) {
      promises.push(
        createPromise(id).catch((error) => {
          return error
        }),
      )
    }

    return new Promise((resolve) => {
      Promise.all(promises).then((result) => {
        resolve(result)
      })
    })
  }

  const getServerUsers = (serverId: string) =>
    get(`/config-api/server/users?serverId=${serverId}`)

  const setServerUsers = (serverId: string, userIds: string[]) =>
    post('/config-api/server/setUsers', { serverId: parseInt(serverId), userIds: userIds.map(id => parseInt(id)) }, false)

  const getServerCompanies = (serverId: string) =>
    get(`/config-api/server/companies?serverId=${serverId}`)

  return {
    getServers,
    addServer,
    editServer,
    deleteServer,
    getServerUsers,
    setServerUsers,
    getServerCompanies,
  }
}

export default {
  create,
}
